<template>
    <div class="block block-entry-meta">
        <journal-entry-meta :entry="block"></journal-entry-meta>
    </div>
</template>

<script>
import JournalEntryMeta from '@/components/journal/JournalEntryMeta';
export default {
    name: 'entryMeta',
    props: ['block'],
    components: {
        JournalEntryMeta,
    },
};
</script>